import src from "IMAGE";
export default { src, width: 1920, height: 900, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAANElEQVR42m2NUQ4AIAhCuf+ZE4pZ5odszCnPAVGiHczZ7AzSB0o39B2dnoR6OkCsrHm7tQHU0X9W82ev8AAAAABJRU5ErkJggg=="};
